/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Status_SendingInputs */



/**
* | output |
* | --- |
* | "Sending" |
*
* @param {Live_Caption_Status_SendingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_status_sending = /** @type {((inputs?: Live_Caption_Status_SendingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Status_SendingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoi")
	if (locale === "de") return /** @type {LocalizedString} */ ("Senden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отправка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Envío")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发送")
	if (locale === "ja") return /** @type {LocalizedString} */ ("送信中")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भेजना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Enviando")
	return /** @type {LocalizedString} */ ("Sending")
});